import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'firstUpper', pure: true })
export class FirstLetterUppercasePipe implements PipeTransform {
  transform(value: string | undefined | null): string {
    return !!value && value.length > 0 ? value.substr(0, 1).toUpperCase().concat(value.substr(1)) : '';
  }
}
